






























































































import Component from 'vue-class-component'
import { Prop } from 'vue-property-decorator'
import Vue from 'vue'
import RespondecoCategories from '../../../shared/components/respondeco-categories.vue'
import { OfferResponse, OrganisationLiteResponse } from '@/api/generated'
import { imageUrl } from '@/shared/utils/images'

@Component({
  components: { RespondecoCategories },
})
export default class OfferSidebar extends Vue {
  @Prop({
    default: () => [],
    type: Array,
  })
  public readonly partners!: OrganisationLiteResponse[]

  @Prop({
    default: () => ({}),
    type: Object,
  })
  public readonly offer!: OfferResponse

  public imageUrl = imageUrl
}
